export const GROUP_LOGS = `
query groupLogs(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: GroupLogOrderInput,
  $filter: FilterGroupLogInput,
  $searchText: String
){
  groupLogs(
    tenant_id:$tenant_id,
    skip:$skip,
    take:$take,
    orderBy:$orderBy,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on GroupLog{
      id
      group_id
      group{
        id
        name
      }
      log_action_id
      log_action{
        id
        name
        translation_key
      }
      user{
        email
        contact {
          firstname
          lastname
        }
      }
      description
      its
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GROUP_LOG_COUNT = `
query groupLogCount(
  $tenant_id: Int!,
  $filter: FilterGroupLogInput,
  $searchText: String
){
  groupLogCount(
    tenant_id:$tenant_id,
    filter:$filter,
    searchText:$searchText
  ){
    __typename
    ...on Count{
      count
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
